<template>
  <div>
    <app-header no_back="true" settings="systemZoom" no_menu="true">esma</app-header>

        <div class="menu">
        <br>
        <br>
        <div class="row menu-btns-container">
            <div class="col-md-offset-1 col-xs-10 menu-btns">
                <div class="entity_select_login">
                    <div class="entity_select_login_title">社名選択</div>
                    <table>
                        <tr>
                            <td style="width:50%">
                                <multi-select msstyle="min-width:100px;width: 95%; height: 120px;border: 1px solid black;" :options="companyOptions" @onSelected="companySelected"></multi-select>
                            </td>
                            <td>
                                <button type="button"
                                @click="onStartClicked"
                                class="btn btn-lg btn-primary entity_select_btn"
                                :disabled="startIsEnabled == false"  title="Start" >スタート</button>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>

  </div>
</template>

<script>
import Vue from "vue";
import MenuBtn from "@/components/menu-btn";
import MultiSelect from "@/components/multi-select";
import constants from "@/rules/constants";
import _ from "lodash";

import { utils } from "@/libs/utils";
import mixinMenuCommon from "@/mixins/mixin_menu_common";
import mixinPageCommon from '@/mixins/mixin_page_common';


import debug from "debug";
var debug_menu = debug("esma:menu");

Vue.component("multi-select", MultiSelect);
Vue.component("menu-btn", MenuBtn);

import { bus } from "@/libs/bus";

export default {
  mixins: [mixinMenuCommon,mixinPageCommon],
  components: {
  },
  //  name: 'Name here',
  data() {
    return {
      start_is_enabled:false,
      allowed_entities:[],
      local_selected_company:"-"
    };
  },
  computed: {
    localSelectedCompany:{
      get(){
        return this.local_selected_company;
      },
      set(v){
        this.local_selected_company = v;
      }
    },
    startIsEnabled:{
      get(){
        return this.start_is_enabled;
      },
      set(v){
        this.start_is_enabled = v;
      }
    },
    lastSelectedCopmanyName() {
      return Vue.localStorage.get("selectedCompany");
    },
    userCopmany() {
      return Vue.localStorage.get("userCompany");
    },
     companyOptions() {

       var roles = Vue.localStorage.get("roleArray");
       if(typeof roles != "undefined"){
         roles = JSON.parse(roles)
       }else{
         return []
       }
      var array_or_roles = roles.map((r)=>{return r.role});

      var localIsMultiCompanyAdmin = this.isMultiCompanyAdminByArray(array_or_roles)
      this.allowed_entities = [];
      var userCopmanies = roles.map((r)=>{return r.company});
      this.allowed_entities=[
        {name: constants.COMPANY.MHFG, value: constants.COMPANY.MHFG, enabled:userCopmanies.indexOf(constants.COMPANY.MHFG) > -1},
        {name: constants.COMPANY.MHBK, value: constants.COMPANY.MHBK, enabled:userCopmanies.indexOf(constants.COMPANY.MHBK) > -1},
        {name: constants.COMPANY.MHTB, value: constants.COMPANY.MHTB, enabled:userCopmanies.indexOf(constants.COMPANY.MHTB) > -1},
        {name: constants.COMPANY.ALL, value: constants.COMPANY.ALL, enabled:localIsMultiCompanyAdmin==true}
      ]
      if (this.allowed_entities && this.allowed_entities.length > 0) {
        var enabled = _.filter(this.allowed_entities,(a =>{return a.enabled == true}));

        var first_enabled = "";
        if(Array.isArray(enabled) && enabled.length > 0){
          first_enabled = enabled[0].value
        }
        var last = this.lastSelectedCopmanyName || first_enabled || "";
        this.allowed_entities.forEach(d => {
          d.selected = d.value == last;
        });
      }
      return this.allowed_entities;
    },
  },
  methods: {
    onStartClicked(){
      if(this.startIsEnabled){
        Vue.localStorage.set("selectedCompany", "-");
        this.$ajax.postExtended("/login/",{selected_company:this.localSelectedCompany},(err, response) => {
          if(response.data.change_password == "yes"){
            this.$router.push("/change_password");
          }else if(response.data.change_expired_password == "yes"){
            this.$router.push("/change_password/expired");
          }else{
            var tab_session_id =  (new Date()).getTime()
            window.sessionStorage.setItem('browser_tab_id',tab_session_id)
            Vue.localStorage.set('browser_tab_id',tab_session_id);

            Vue.localStorage.set('userShimei',response.data.user_data.user_shimei);
            Vue.localStorage.set('userID',response.data.user_data.user_id);
            Vue.localStorage.set('userRole',response.data.user_data.user_role);
            Vue.localStorage.set('userCompany',response.data.user_data.user_company);
            Vue.localStorage.set('userDepartment',response.data.user_data.user_department);
            Vue.localStorage.set('userTeam',response.data.user_data.user_team);
            Vue.localStorage.set('passwordExpireDate',response.data.user_data.password_expire_date);
            Vue.localStorage.set("selectedCompany", response.data.user_data.user_company);
            Vue.localStorage.remove("roleArray");
            this.$store.state.show_message_after_login = true;
            this.resetMenuUserPermission();
            this.$router.push("/menu");
          }
        })
      }
    },
    companySelected(s) {
      // Vue.localStorage.set("selectedCompany", "-");
      this.localSelectedCompany = "-"
      var comp = _.find(this.allowed_entities,(f)=>{return f.value == s.selected})
      this.startIsEnabled = (typeof comp != "undefined" && comp.enabled == true);
      if(this.startIsEnabled){
        this.localSelectedCompany =s.data.name
        // Vue.localStorage.set("selectedCompany", s.data.name);
      }
    }
  },
  created() {},
  mounted() {
      this.resetMenuUserPermission();

      this.$ajax.post('/ping', {}, (err, response) => {
          console.log("Ping response at company",{err,response})
      })
  },
};
</script>
<style scoped>
.entity_select_login_title {
  top: -38px;
  position: relative;
  width: 120px;
  background: white;
  padding: 0px 10px;
}
.entity_select_login {
  margin-top: 30px;
  text-align: left;
  border: solid 1px #000000;
  padding: 30px;
  width: 400px;
  margin-left: 49px;
}
.entity_select_select {
  width: 200px;
  height: 120px;
}
.entity_select_btn {
  white-space: normal;
  height: 50px;
  margin: 30px;
  width: 110px;
}
.menu {
  text-align: center;
}

.menu-btns {
  text-align: center;
  padding: 0px;
}

.menu-btns-container {
  text-align: center;
  max-width: 1100px;
  margin: auto;
  padding: 0px;
}

.box {
    margin-top: 5px;
    background: #FFFFFF;
    border: 1px solid #337ab7;
    border-radius: 5px;
    height: 300px;

}
.box .box-title {
    background: #bdd6ec;
    padding: 4px;
    text-align: left;
    font-weight: bold;
    letter-spacing: 0.05em;
    border-radius: 5px 5px 0 0;
}
.box p {
    padding: 15px 20px;
    margin: 0;
    text-align: left;
}
</style>



// WEBPACK FOOTER //
// company.vue?3d5cec5e